module.exports = __webpack_public_path__ + "static/media/Depositos.659d8397.png";